export default __webpack_public_path__ + "static/media/bg_romulus_all.401bef69.svg";